<template>
  <div class="ppcThumbnailCard pointer"
       :class="[{'selected' : selected}, creativeType]"
       @click="(!child) ? $parent.selectCreative(index) : $parent.selectCreativeById(creative.id)"
       data-vtf="vtf"
       v-if="((!child && creative.parent_id == 0) || (child && creative.parent_id != 0)) && (accountView || designerView || (!accountView && (creative.status == 'live' || creative.status == 'done' || creative.status == 'rejected')))"
  >
    <md-card :class="{'new' : !seenbyUser}">
      <img v-if="newCommentsForUser > 0" class="ppcThumbnailCard--comment-alert" src="../assets/img/comment.svg"
           alt="comment alert">
      <md-card-media>
        <img
            v-if="creative.thumb"
            :srcset="(creative.thumb) ? creative.thumb.srcset : ''"
            :src="apiUrl + creative.thumb.path + creative.thumb.file_name"
            :alt="creative.name"
            class="creative-img"
        />
      </md-card-media>

      <div class="statusContainer">
        <div
            v-bind:class="{
            statusButtonOnClient: status === 'ONCLIENT',
            statusButtonInProgress: status === 'ONAGENCY' ,
            statusButtonReadyToSend: status === 'READYTOSEND',
            statusButtonApproved: status === 'APPROVED',
            statusButtonRejected: status === 'REJECTED',
          }"
            class="statusButton"
        >
        
          {{ statusToTitle(status) }}
        </div>
      </div>

      <md-card-content class="cardImageSize">{{
          (creative.name == "") ? creative.width + "x" + creative.height : creative.name
        }}
      </md-card-content>
      <!-- <div
        v-if="creative.comment_status == 'account' && creative.status != 'done'"
        style="text-align: center;"
      >
        <editCreative v-if="accountView" :board="board" :creative="creative" />
      </div> -->
      <md-divider class="divider"></md-divider>
      <md-card-content
          class="cardVersionNumber"
      >Version:{{ parseInt(creative.version) + 1 }}
      </md-card-content
      >
    </md-card>
  </div>
</template>

<script>
// import editCreative from "@/components/pagesComponents/brand/editCreative.vue";
export default {
  name: "PPCThumbnailCard",

  props: ["child","creative", "index", 'selected', "board", "accountView","designerView", "selectedidx"],
  // components: { editCreative },
  methods: {
    statusToTitle(status) {
      switch (status) {
        case "ONCLIENT":
          return "On Client";
        case "ONAGENCY":
          return "On Agency";
        case "APPROVED":
          return "Approved";
        case "READYTOSEND":
          return "Ready to send";
        case "REJECTED":
          return "Rejected";
        default:
          return status;
      }
    },
  },
  computed: {
    seenbyUser(){
      var _this = this;
      if (this.creative.creative_seen)
      {
        var seen = this.creative.creative_seen.filter(element => {
          return element.user_id == _this.$store.state.user.id
        });
        
        return seen.length > 0;
      }
      return false;
    },
    newCommentsForUser(){
      var _this = this;
      if (this.creative.comment)
      {
        var newcomments = this.creative.comment.filter(element => {
          if (element.user_id == _this.$store.state.user.id)
          {
            return false;
          }
          if (element.comment_seen)
          {
            
            return element.comment_seen.filter(cs => {
             return cs.user_id == _this.$store.state.user.id
            }).length == 0   
          }
          else
          {

            return true;
          }
        });

       
        return newcomments.length;
      }
      return 0;
    },
    status() {
      if (this.creative.status == "draft") {
        return "READYTOSEND";
      }
      if (this.creative.status == "rejected") {
        return "REJECTED";
      }
      if (this.creative.status == "live") {
        if (this.creative.comment_status == "account") return "ONAGENCY";
        if (this.creative.comment_status == "need_more_info") return "ONAGENCY";
        if (this.creative.comment_status == "client") return "ONCLIENT";
        if (this.creative.comment_status == "done") return "ONAGENCY";
      }
      if (this.creative.status == "done") {
        return "APPROVED";
      }
      return "";
    },
    creativeType() {
      var imageWidth = this.creative.width
      var imageHeight = this.creative.height

      if (imageWidth && imageHeight) {
        if (imageWidth === imageHeight) {
          return 'square'
        } else if (imageHeight > imageWidth) {
          return 'portrait'
        } else {
          return 'rectangle'
        }
      } else {
        return 'document'
      }

    }
  },
};
</script>

<style scoped>
  .new{
    border: 2px solid red;
  }
</style>